import { render, staticRenderFns } from "./DevDesignTypography.vue?vue&type=template&id=de4af556"
import script from "./DevDesignTypography.vue?vue&type=script&lang=js"
export * from "./DevDesignTypography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports